const map = {
	"./Airplane_GameIcon.png": "./src/assets/games_icons/Airplane_GameIcon.png",
	"./Alchemix_GameIcon.png": "./src/assets/games_icons/Alchemix_GameIcon.png",
	"./CarRacer_GameIcon.png": "./src/assets/games_icons/CarRacer_GameIcon.png",
	"./Climbing_GameIcon.png": "./src/assets/games_icons/Climbing_GameIcon.png",
	"./CrossTheRoad_GameIcon.png": "./src/assets/games_icons/CrossTheRoad_GameIcon.png",
	"./Default_GameIcon.png": "./src/assets/games_icons/Default_GameIcon.png",
	"./FlyingCar_GameIcon.png": "./src/assets/games_icons/FlyingCar_GameIcon.png",
	"./FlyingCarpet_GameIcon.png": "./src/assets/games_icons/FlyingCarpet_GameIcon.png",
	"./FrogJourney_GameIcon.png": "./src/assets/games_icons/FrogJourney_GameIcon.png",
	"./GardenRage_GameIcon.png": "./src/assets/games_icons/GardenRage_GameIcon.png",
	"./JapaneseGarden_GameIcon.png": "./src/assets/games_icons/JapaneseGarden_GameIcon.png",
	"./LineRoller_GameIcon.png": "./src/assets/games_icons/LineRoller_GameIcon.png",
	"./Mind4_GameIcon.png": "./src/assets/games_icons/Mind4_GameIcon.png",
	"./MineCart_GameIcon.png": "./src/assets/games_icons/MineCart_GameIcon.png",
	"./Octopulse_GameIcon.png": "./src/assets/games_icons/Octopulse_GameIcon.png",
	"./SkiLiner_GameIcon.png": "./src/assets/games_icons/SkiLiner_GameIcon.png",
	"./SpaceBurger_GameIcon.png": "./src/assets/games_icons/SpaceBurger_GameIcon.png",
	"./Stardust_GameIcon.png": "./src/assets/games_icons/Stardust_GameIcon.png",
	"./ToapRun_GameIcon.png": "./src/assets/games_icons/ToapRun_GameIcon.png",
	"./TowerBuilder_GameIcon.png": "./src/assets/games_icons/TowerBuilder_GameIcon.png",
	"./WitcherDefense_GameIcon.png": "./src/assets/games_icons/WitcherDefense_GameIcon.png"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/games_icons sync recursive ^\\.\\/.*\\.png$";